import { UserSettingService } from '../../services/UserSetting.service'
import OktaUserDetails from "../../Helpers/OktaUserDetails"

const state = {
    userSettingData: [],
    userSettingDataAck: '',
    tblCohortListFilters: [],
}

// getters
const getters = {
}

function getUserId() {
    return new OktaUserDetails().getUserId();
}
// actions
const actions = {

    settblCohortListFilters({ commit }, userSettingData) {
        commit('settblCohortListFilters', { userSettingData });
    },

    getUserSettingData({ commit, rootState }) {
        //console.log('called');

        let clientId = rootState.UserManagementStore.UserClientId;
        let userId = getUserId();
        let productLine = rootState.AppStore.ProductLine.payload.trim();
        const params = 'productType=' + productLine + '&clientID=' + clientId + '&userid=' + userId + '&moduleId=4'

        return new Promise((resolve, reject) => {
            UserSettingService.getUserSettingData(
                params,
                userSettingData => {
                    commit('setUserSettingData', { userSettingData });
                        resolve()
                },
                err => {
                    reject(err)
                })
        })
    },

    saveUserSettingData({ commit, rootState }, userSettingData) {
        let clientId = rootState.UserManagementStore.UserClientId;
        let userId = getUserId();
        let productLine = rootState.AppStore.ProductLine.payload.trim();
        //let userName = rootState.Authentication.user.firstName + ' ' + rootState.Authentication.user.lastName;
        let userName = getUserId();
        const params = {
            "userId": userId,
            "clientId": clientId,
            "adminYear": `${ process.env.VUE_APP_ADMINYEAR }`,
            "productType": productLine,
            "moduleId": 4,
            "userSettingId": userSettingData.userSettingId,
            "SettingName": userSettingData.cohortName,
            "ShowOnDefault": 0,
            "UpdatedBy": userName,
            "ItemResponse":
            {
                "SelectedOptions": userSettingData.modelNewCohortFilters
            }
        }
        return new Promise((resolve, reject) => {
            UserSettingService.saveUserSettingData(
                params,
                userSettingDataAck => {
                    commit('saveUserSettingData', { userSettingDataAck });
                    resolve()
                },
                err => {
                    reject(err)
                })
        })
    },
}

// mutations
const mutations = {
    settblCohortListFilters(state, { userSettingData }) {
        state.tblCohortListFilters = userSettingData;
    },

    setUserSettingData(state, { userSettingData }) {
        for (var i = 0; i <  userSettingData.length; i++) {
            for (var j = 0; j < state.userSettingData.length; j++) {
                var newUserSetting = userSettingData[i];
                var stateUserSetting = state.userSettingData[j];
                if (stateUserSetting.userSettingId == newUserSetting.userSettingId) {
                    newUserSetting.showOnDefault = stateUserSetting.showOnDefault;
                }
            }
        }
        //state.tblCohortListFilters = userSettingData;
        state.userSettingData = userSettingData
    },

    saveUserSettingData(state, { userSettingDataAck }) {
        //state.userSettingData.push(userSettingDataAck);
        //state.userSettingData = [];
        state.userSettingDataAck = userSettingDataAck;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}